export default "__VITE_ASSET__BGEdnwej__"